// example of EVERY components with view variations
const baseUIVariantConfig = {
  CourseBannerCard: 'VerticalWithExpiry',
  CourseFilter: 'Selection',
  CourseListCard: 'HorizontalWithExpiry',
  CourseListLayout: 'FlexList',
  HamburgerMenu: 'Light',
  Modal: 'Rounded',
  MyCourseTitle: 'Light_Large',
  Notification: 'Filled',
  Sidebar: 'Flat',
  ToCVariant: 'Flat',
};

/**
 *
 * *Work In Progress*
 *
 * @param {('A'|'B'|'C')} uiVariantSet Example
 * @returns {{
 *  CourseBannerCard: ('VerticalWithExpiry'|'VerticalWithProgress'),
 *  CourseFilter: ('Selection'|'SlideUp'),
 *  CourseListCard: ('HorizontalWithExpiry'|'VerticalWithExpiry_SMALL'|'VerticalWithProgress_SMALL'|'HorizontalWithProgress'),
 *  CourseListLayout: ('GridList'|'FlexList'),
 *  HamburgerMenu: ('Light'|'Dark'|'Branding'),
 *  Modal: ('Flat'|'Rounded'),
 *  Notification: ('Filled'|'Outlined'),
 *  ToCVariant: ('Flat'|'WithContentTypeIcon'|'WithRoundHighlight'),
 *  Sidebar: ('Flat'|'WithIcon')
 * }}  Object containing variant string for view components
 */
const getUIVariantConfig = (uiVariantSet) => {
  let extendingConfig = {}; //anywhere

  if (uiVariantSet === 'A') {
    extendingConfig = {
      CourseBannerCard: 'VerticalWithExpiry',
      CourseFilter: 'SlideUp',
      CourseListCard: 'VerticalWithExpiry_SMALL',
      CourseListLayout: 'GridList',
      HamburgerMenu: 'Branding',
      Modal: 'Rounded',
      MyCourseTitle: 'Light',
      Notification: 'Outlined', //now unused with withFixedSidebar layout
      Sidebar: 'WithIcon', //now unused with withFixedSidebar layout
      ToCVariant: 'WithContentTypeIcon',
    }; //deg,dgt,tmk,lacad
  } else if (uiVariantSet === 'B') {
    extendingConfig = {
      CourseBannerCard: 'VerticalWithExpiry',
      CourseFilter: 'SlideUp',
      CourseListCard: 'VerticalWithExpiry_SMALL',
      CourseListLayout: 'GridList',
      HamburgerMenu: 'Branding',
      Modal: 'Rounded',
      MyCourseTitle: 'Dark',
      Notification: 'Outlined', //now unused with withFixedSidebar layout
      ToCVariant: 'WithContentTypeIcon', //now unused with withFixedSidebar layout
      Sidebar: 'WithIcon',
    }; //skd,skd-app,paas-sk,fram
  } else if (uiVariantSet === 'C') {
    extendingConfig = {
      CourseBannerCard: 'VerticalWithProgress',
      CourseFilter: 'Selection',
      CourseListCard: 'HorizontalWithProgress',
      CourseListLayout: 'FlexList',
      MyCourseTitle: 'Light',
      ToCVariant: 'WithRoundHighlight',
    };
  } else if (uiVariantSet === 'D') {
    extendingConfig = {
      CourseFilter: 'SlideUp',
      CourseListCard: 'VerticalWithExpiry_SMALL',
      CourseListLayout: 'GridList',
      HamburgerMenu: 'Branding',
      Modal: 'Rounded',
      MyCourseTitle: 'Light',
      Notification: 'Outlined',
      Sidebar: 'WithIcon',
      ToCVariant: 'WithContentTypeIcon',
    };
  }

  // TODO: might need merge lib to extend deep objects
  // e.g. https://github.com/chakra-ui/chakra-ui/blob/main/packages/react/src/extend-theme.ts
  return { ...baseUIVariantConfig, ...extendingConfig };
};

const getAppUIVariantConfig = () => getUIVariantConfig(window.appConfig?.uiVariantSet);

export { getUIVariantConfig, getAppUIVariantConfig };
